import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CircularProgress,
  Chip,
  Paper,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { fetchAgentById } from "../../../../../features/slices/Agent";
import Title from "../../../../../components/Title";
import Back from "../../../../../components/Back";
import { JsonEditor } from "json-edit-react";
import { Agent } from "../../../../../interfaces";

const AgentView = () => {
  const { agentId } = useParams();
  const [agent, setAgent] = useState<Agent | null>(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const getAgent = async () => {
      const result = await dispatch(fetchAgentById(agentId));
      if (result.payload) {
        setAgent(result.payload);
      }
      setLoading(false);
    };

    getAgent();
  }, [dispatch, agentId]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!agent) {
    return (
      <Typography variant="h6" color="error" align="center" sx={{ mt: 4 }}>
        Agent not found
      </Typography>
    );
  }

  return (
    <>
      <Box
        sx={{ p: 4, backgroundColor: "background.default", minHeight: "100vh" }}
      >
        <Title>Agent Details {agentId}</Title>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  General Information
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>Title:</strong> {agent.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>Host:</strong> {agent.host}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>UUID:</strong> {agent.UUID}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>OS Type:</strong> {agent.os_type}
                </Typography>
                <Box mt={2}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    display="inline"
                  >
                    <strong>State:</strong>{" "}
                  </Typography>
                  <Chip
                    label={agent.state ? "Active" : "Inactive"}
                    color={agent.state ? "success" : "error"}
                    size="small"
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Network Information
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>Group:</strong> {agent.logic_group}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>Subnet:</strong> {agent.subnet}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Meta Data
                </Typography>
                <JsonEditor
                  data={agent.meta_data}
                  restrictAdd={true}
                  restrictDelete={true}
                  restrictEdit={true}
                  allowedModes={["code", "tree"]}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Back />
    </>
  );
};

export default AgentView;
